import React from "react";
import { useNavigate } from "react-router-dom";

const EmploymentDetails = () => {
  const navigate = useNavigate();

  return (
    <div className="p-8">
      {/* Header */}
      <h1 className="text-5xl font-bold text-slate-900 mb-2">
        Employment Details
      </h1>

      <p className="text-slate-500 text-2xl mb-8">
        Step 2 of Employee Creation
      </p>

      {/* Stepper */}
      <div className="bg-white border border-slate-200 rounded-3xl p-8 mb-8">
        <div className="flex items-center justify-between">
          {/* Personal */}
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold">
              ✓
            </div>
            <span className="mt-2 text-sm font-medium text-green-600">
              Personal
            </span>
          </div>

          <div className="flex-1 h-1 bg-green-500 mx-4"></div>

          {/* Employment */}
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
              🏢
            </div>
            <span className="mt-2 text-sm font-medium text-blue-600">
              Employment
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4"></div>

          {/* Salary */}
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
              💰
            </div>
            <span className="mt-2 text-sm font-medium text-slate-400">
              Salary
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4"></div>

          {/* Emergency */}
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
              📞
            </div>
            <span className="mt-2 text-sm font-medium text-slate-400">
              Emergency
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4"></div>

          {/* Documents */}
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
              📄
            </div>
            <span className="mt-2 text-sm font-medium text-slate-400">
              Documents
            </span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm">
        {/* Card Title */}
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
            🏢
          </div>

          <h2 className="text-2xl font-semibold text-slate-800">
            Employment Details
          </h2>
        </div>

        {/* Form */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Department */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Department *
            </label>

            <select className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Engineering</option>
              <option>HR</option>
              <option>Finance</option>
              <option>Sales</option>
              <option>Marketing</option>
            </select>
          </div>

          {/* Designation */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Designation *
            </label>

            <select className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Software Engineer</option>
              <option>Frontend Developer</option>
              <option>Backend Developer</option>
              <option>HR Executive</option>
              <option>Manager</option>
            </select>
          </div>

          {/* Employment Type */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Employment Type *
            </label>

            <select className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Full Time</option>
              <option>Part Time</option>
              <option>Intern</option>
              <option>Contract</option>
            </select>
          </div>

          {/* Reporting Manager */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Reporting Manager *
            </label>

            <select className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Rahul Sharma (EMP-1001)</option>
              <option>Rohan Patil (EMP-1002)</option>
              <option>Nisha Patil (EMP-1003)</option>
            </select>
          </div>

          {/* Work Location */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Work Location *
            </label>

            <select className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Mumbai, India</option>
              <option>Pune, India</option>
              <option>Bangalore, India</option>
              <option>Hyderabad, India</option>
            </select>
          </div>

          {/* Date of Joining */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Date of Joining *
            </label>

            <input
              type="date"
              className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Employee Status */}
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Employee Status *
            </label>

            <select className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Active</option>
              <option>Probation</option>
              <option>Inactive</option>
            </select>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-10">
          <button
            onClick={() => navigate("/hr/employee/add")}
            className="px-6 py-3 border border-slate-300 rounded-xl hover:bg-slate-50"
          >
            ← Previous
          </button>

          <button
            onClick={() => navigate("/hr/employee/add/salary")}
            className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700"
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmploymentDetails;